<div class="container-fluid">
  <div class="card">
    <div class="card-title orange-border">
      <div class="form-group display-inline">
        <div [pTooltip]="isSubscriptionValid && !isGuestAdminUser() ? null : getTooltipText"
          class="disabled-tooltip-wrapper">
          <button (click)="create()"
            [disabled]="isGuestAdminUser() || !isSubscriptionValid"
            class="cursor-pointer display-inline navy-btn"
            type="button">
            <i class="fa fa-user-plus circle-style"></i>
            <p class="display-inline" id="new-user-label">Add new user</p>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">

      <div class="form-group">
        <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i> No user invitations found. </h3>
          </div>
          <app-search-view>
            <app-user-invitation-search filters></app-user-invitation-search>
            <table class="table table-hover table-responsive-md table-wrap-sm-2" grid>
              <thead>
                <tr>
                  <th scope="col"><h3>Email</h3></th>
                  <th scope="col"><h3>Role</h3></th>
                  <th class="text-center" scope="col"><h3>Send</h3></th>
                  <th class="text-center" scope="col"><h3>Delete</h3></th>
                </tr>
              </thead>
              <tbody class="table-hover text-nowrap">
                @for (userInvitation of content; track userInvitation) {
                  <tr class="cursor-pointer active-color">
                    <td (click)="view(userInvitation)">
                      <span class="p-column-title">Email</span>
                      {{ userInvitation.email }}
                    </td>
                    <td (click)="view(userInvitation)">
                      <span class="p-column-title">Role</span>
                      {{ userInvitation.role.description }}
                    </td>
                    <hr/>
                    <td>
                      <div>
                        <div (click)="resend(userInvitation)" class="circle-style">
                          <i class="fa fa-send fa-lg"></i>
                        </div>
                        <span class="p-column-title ">Send</span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <div (click)="deleteUserInvitation(userInvitation)" class="circle-style">
                          <i class="fa fa-trash fa-lg"></i>
                        </div>
                        <span class="p-column-title ">Delete</span>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </app-search-view>
        </div>
      </div>
    </div>
  </div>